import environment from '../config/environment';
import interpolate from'../lib/interpolat';

const url = 'http{ssl}://{domain}{port}/{vdir}{api}/'.interpolate(environment.server);

export default url;